/** Client-side phone helpers. Backend `normalize_phone` remains authoritative. */

export const PHONE_MIN_DIGITS = 6;
export const PHONE_MAX_LENGTH = 40;

export function countPhoneDigits(value) {
  return String(value || '').replace(/\D/g, '').length;
}

export function isPhoneValid(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return false;
  if (trimmed.length > PHONE_MAX_LENGTH) return false;
  return countPhoneDigits(trimmed) >= PHONE_MIN_DIGITS;
}
